import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    auth: false,
    back: "",
    imatges: [],
    connectionError: {
      show: false,
      message: '',
      type: 'network',
      canRetry: true,
      retryCount: 0
    }
  },
  mutations: {
    setAuth(state, auth) {
      state.auth = auth;
    },
    setBack(state, back) {
      state.back = back;
    },
    setImatges(state, imatges) {
      state.imatges = imatges;
    },
    showConnectionError(state, errorData) {
      state.connectionError = {
        show: true,
        message: errorData.message,
        type: errorData.type,
        canRetry: errorData.canRetry,
        retryCount: state.connectionError.retryCount + 1
      };
    },
    hideConnectionError(state) {
      state.connectionError = {
        show: false,
        message: '',
        type: 'network',
        canRetry: true,
        retryCount: 0
      };
    },
    incrementRetryCount(state) {
      state.connectionError.retryCount++;
    }
  },
  actions: {
  },
  modules: {
  }
})
